import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { Grid, InputAdornment } from '@mui/material';

const TimeCounter = ({ setTime, time }) => {
    // Función para manejar el evento de rueda
    const handleWheel = (event) => {
        // Si la rueda va hacia arriba, sumamos 15 minutos
        if (event.deltaY < 0) {
            setTime((prevTime) => prevTime + 15);
        }
        // Si la rueda va hacia abajo, restamos 15 minutos
        else if (event.deltaY > 0) {
            setTime((prevTime) => Math.max(0, prevTime - 15)); // Evitamos que sea negativo
        }
    };

    // Función para aumentar 15 minutos
    const increaseTime = () => {
        setTime((prevTime) => prevTime + 15);
    };

    // Función para disminuir 15 minutos
    const decreaseTime = () => {
        setTime((prevTime) => Math.max(0, prevTime - 15)); // Evitamos que sea negativo
    };

    return (
        <Grid
            container
            direction="row"
            justifyContent="start"
            alignItems="center"
            xs={12}
            gap={1}
        >
            <Button
                variant="outlined"
                color="primary"
                size='medium'
                onClick={decreaseTime}
                sx={{ height: 39 }}
            >
                <ArrowDownwardIcon fontSize='medium' />
            </Button>

            <Grid item xs={3}>
                <TextField
                    label="Tiempo"
                    variant="outlined"
                    id="input-with-icon-textfield"
                    size='small'
                    slotProps={{
                        input: {
                            startAdornment: (
                                <InputAdornment position="start">
                                    <ArrowDownwardIcon />
                                </InputAdornment>
                            ),
                        },
                    }}
                    value={`${Math.floor(time / 60)}h ${time % 60}m`} // Formato "Xh Xm"
                    InputProps={{
                        readOnly: true, // No permitir edición manual
                        onWheel: handleWheel // Agregar el manejador del evento de rueda solo a este TextField
                    }}
                />
            </Grid>

            <Button
                variant="contained"
                color="primary"
                size='medium'
                onClick={increaseTime}
                sx={{ height: 39 }}
            >
                <ArrowUpwardIcon fontSize='medium' />
            </Button>
        </Grid>
    );
};

export default TimeCounter;